import { Routes, Route, Navigate, useParams, useLocation } from "react-router-dom";
import alqemiDataService from "../api/AlqemiDataService";
import DataLoadingWrapper from "../common/components/utils/DataLoadingWrapper";
import OfferProvider from "./context/OfferProvider";
import { StepNavigationProvider } from "./context/StepNavigationContext";
import { EmailFeedbackProvider } from "./context/EmailFeedbackContext";
import OverallReviewStep from "./MatchPage/Steps/OverallReviewStep";
import CVAdaptationStep from "./MatchPage/Steps/CVAdaptationStep";
import EmailReviewStep from "./MatchPage/Steps/EmailReviewStep";
import FeedbackStep from "./MatchPage/Steps/FeedbackStep";

function RedirectWithQueryParams() {
  const location = useLocation();
  // Preserve query parameters when redirecting
  return <Navigate to={`review${location.search}`} replace />;
}

function AlqemiStepWrapper() {
  const { offerId } = useParams();

  const getOfferFromLocation = async () => {
    return alqemiDataService.getOffer(offerId || "");
  };

  return (
    <DataLoadingWrapper
      ContextProvider={OfferProvider}
      fetchFunctions={[getOfferFromLocation]}
      observeParam={offerId}
    >
      <StepNavigationProvider>
        <EmailFeedbackProvider>
          <Routes>
            <Route path="/" element={<RedirectWithQueryParams />} />
            <Route path="review" element={<OverallReviewStep />} />
            <Route path="cv-adaptation" element={<CVAdaptationStep />} />
            <Route path="email-review" element={<EmailReviewStep />} />
            <Route path="feedback" element={<FeedbackStep />} />
          </Routes>
        </EmailFeedbackProvider>
      </StepNavigationProvider>
    </DataLoadingWrapper>
  );
}

export default function AlqemiWrapper() {
  return <AlqemiStepWrapper />;
}
